export const categoryInfos = [
  {
    title: "Electronics",
    name: "electronics",
    imgLink: "https://m.media-amazon.com/images/I/613hl1+-0HL._AC_SL1200_.jpg",
  },
  {
    title: "Discover fashion trends",
    name: "women's clothing",
    imgLink: "https://m.media-amazon.com/images/I/61qyWJ6kMwL._AC_SL1237_.jpg",
  },
  {
    title: "Men's Clothing",
    name: "men's clothing",
    imgLink: "https://m.media-amazon.com/images/I/71Wvtu7MzSL._AC_SL1500_.jpg",
  },
  {
    title: "Jewelery",
    name: "jewelery",
    imgLink: "https://m.media-amazon.com/images/I/61x0FjqGChL._AC_SL1500_.jpg",
  },
];
  